<ng-container
*ngIf="operationTemplateRef_hd"
[ngTemplateOutlet]="operationTemplateRef_hd"
[ngTemplateOutletContext]="{$implicit:topData}"
>
</ng-container>
<div style="display: flex;">
    <div class="dropdown" *ngIf="filter_title == true" style="margin-right: 0.5%;margin-top: 0.5%;">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            顯示的欄位
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" [id]="'checkboxall'" [(ngModel)]="search_all_val" (change)="search_all()">
                <label class="form-check-label" [for]="'checkboxall'" (click)="$event.stopPropagation()">
                    全選
                </label>
            </div> 
            <div class="form-check" *ngFor="let option of options; let i = index">
                <input class="form-check-input" type="checkbox" [id]="'checkbox' + i" [value]="option.title" [(ngModel)]="selectedOptions[option.title]"  (change)="search_option()">
                <label class="form-check-label" [for]="'checkbox' + i" (click)="$event.stopPropagation()">
                    {{ option.title }}
                </label>
            </div>
        </div>
    </div>

    <div class="export" style="margin-top: 0.5%;margin-right: 0.5%;" *ngIf="urltoken?.length > 0">
        <a  href="{{urltoken}}" target="_blank"  class="btn btn-info">匯出</a>
    </div>
    <div class="export" style="margin-top: 0.5%;" *ngIf="urltokencsv?.length > 0">
        <a  href="{{urltokencsv}}" target="_blank"  class="btn btn-info">匯出csv</a>
    </div>
</div>


<!-- loadmore -->
<table id="lists-chats"  class="lists-chats scrollbar" *ngIf=" loadmore == 1"   (scroll)="onScroll()">
   
    <div *ngIf="pageobj?.total_count > 0" style="margin-bottom: 10px">
        <span>
            第<input type="number" id="numericInputs" [(ngModel)]="input_tmp_page" (change)="inputpage()" name="numericInputs" min="0" max="100">筆
        </span>
        <span>
            第 {{page_start}} - {{page_end}} 筆   總筆數:{{pageobj.total_count}}
        </span>  
    </div>
    <thead [style]="' position: sticky; top: 0; z-index: 100;'">
        <tr *ngIf="titleTableName.length > 0">
            <th>
                {{titleTableName[0].name}}
            </th>
            <th *ngFor="let item of titleTableContent; let i = index" [attr.colSpan]="item.colspan" [style.background-color]="colorArray[i]" [style.color]="'white'">
                {{item.name}}
            </th>
        </tr>
        <tr *ngIf="titleTableName.length > 0 && sumopt == true">
            <th>
                合計
            </th>
            <th *ngFor="let item of tcontentTit; let i = index" [attr.colSpan]="'1'">
                {{aSum[item.content]| dynamicFormat:'number'}}
            </th>
        </tr>
        <tr>
            <th *ngIf="topData.length > 0">
                <input type="checkbox" (change)="CheckboxChange()" />
            </th>
            <th *ngFor="let detal of title let i = index" 
                (click)="sort_fnx(content[i].content, sort_obj.sort, detal.sort)"
                [style]="detal.css" 
                [ngClass]="{
                    'sorting': detal.sort,
                    'sorting_asc': sort_obj.column === content[i].content && sort_obj.sort === '0',
                    'sorting_desc': sort_obj.column === content[i].content && sort_obj.sort !== '0'
                }">
                <ng-container *ngIf="detal.sort; else notSortable">
                    <span>
                        {{ detal.title }}
                    </span>
                </ng-container>
                <ng-template #notSortable>
                    {{ detal.title }}
                </ng-template>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let dataitem of data let i = index">
            <td *ngIf="topData.length > 0">
                <input type="checkbox" [(ngModel)]="topData[i].selected" />
            </td>
            <td *ngFor="let item of content"   [style]="item.css" >

                <div *ngIf="item.type == 3">
                    <ng-container
                        *ngIf="operationTemplateRef_dk"
                        [ngTemplateOutlet]="operationTemplateRef_dk"
                        [ngTemplateOutletContext]="{$implicit:{idx: i, key:item.content,val:dataitem}}"
                    >
                    </ng-container>
                </div>

                <div *ngIf="item.type == 1">
                    <div class="picborder" *ngIf="bounty_id.includes(dataitem.id)">
                        <p>wanted</p>
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                        <div *ngFor="let bountyitem of bounty_arr">
                            <p *ngIf="bountyitem.user_id == dataitem.id">NT {{bountyitem.diamond}}</p>
                        </div> 
                    </div>
                    <div *ngIf="!bounty_id.includes(dataitem.id)">
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">    
                    </div>
                </div> 

                <div *ngIf="item.type == 2">
                    <app-userandactive  [post]="dataitem"></app-userandactive>
                </div> 

                <div *ngIf="item.type != 1 && item.type != 2 && item.type != 3 && item?.model != 1 && item?.model != 2">
                    {{ item.replaceArr ? item.replaceArr[dataitem[item.content]] : dataitem[item.content] | dynamicFormat:item?.format }}
                </div>
                
                <div *ngIf="item?.model == 1">
                    <a href="javascript:void(0)" (click)="handleClick(dataitem[item.handlelinkvalue])">{{ dataitem[item.content] | dynamicFormat:item?.format }}</a>
                </div>
                <div *ngIf="item?.model == 2" [innerHTML]="custom" (click)="handleClick(dataitem)"></div>
            </td>
        </tr>
    </tbody>
</table>


<!-- pc正常版 -->
<table [style.padding.px]="paddingInput" class="lists-chat" *ngIf="(isMobile == false || isMobile && type == 1) && loadmore != 1" >
    <div *ngIf="pageobj?.total_count > 0" style="margin-bottom: 10px">
        <span>
            第<input type="number" id="numericInputs" [(ngModel)]="input_tmp_page" (change)="inputpage()" name="numericInputs" min="0" max="100">筆
        </span>
        <span>
            第 {{page_start}} - {{page_end}} 筆   總筆數:{{pageobj.total_count}}
        </span>  
    </div>
    <thead>
        <tr *ngIf="titleTableName.length > 0">
            <th>
                {{titleTableName[0].name}}
            </th>
            <th *ngFor="let item of titleTableContent; let i = index" [attr.colSpan]="item.colspan" [style.background-color]="colorArray[i]" [style.color]="'white'">
                {{item.name}}
            </th>
        </tr>
        <tr *ngIf="titleTableName.length > 0 && sumopt == true">
            <th>
                合計
            </th>
            <th *ngFor="let item of tcontentTit; let i = index" [attr.colSpan]="'1'">
                {{aSum[item.content]| dynamicFormat:'number'}}
            </th>
        </tr>
        <tr>
            <th *ngIf="topData.length > 0">
                <input type="checkbox" (change)="CheckboxChange()" />
            </th>
            <!-- <th *ngFor="let detal of title let i = index" 
            (click)="sort_fnx(content[i].content, sort_obj.sort, detal.sort)"
            [style]="detal.css" 
                [ngClass]="{
                    'sorting': detal.sort,
                    'sorting_asc': sort_obj.column === content[i].content && sort_obj.sort === '0',
                    'sorting_desc': sort_obj.column === content[i].content && sort_obj.sort !== '0'
                }">
                <ng-container *ngIf="detal.sort; else notSortable">
                    <span>
                        {{ detal.title }}
                    </span>
                </ng-container>
                <ng-template #notSortable>
                    {{ detal.title }}
                </ng-template>
            </th> -->
			<th
    			*ngFor="let detal of title; let i = index"
    			[style]="detal.css"
    			[ngClass]="{
        			'sorting1': detal.sort,
        			'sorting_asc': sort_obj.column === content[i].content && sort_obj.sort === '0',
        			'sorting_desc': sort_obj.column === content[i].content && sort_obj.sort !== '0'
    			}"
			>

    			<ng-container *ngIf="(detal.sort || detal.open); else notSortable">
					<span style="padding:20px">
    			        {{ detal.title }}
    			    </span>
    			    <span class="sort-arrows">
						<div style="display: flex;"  *ngIf="detal.sort">
							<div (click)="sort_fnx(content[i].content, sort_obj.sort, detal.sort)" style="margin:auto;cursor: pointer;">
								<i class="arrow up"></i>
								<i class="arrow down"></i>
							</div>
							<div *ngIf="detal.open;" (click)="sort_fnx_open(content[i].content, sort_obj.sort, detal.sort)"  style="cursor: pointer;">
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:65%"  *ngIf=" open_obj.column != content[i].content && open_obj.activity != '1' || (open_obj.open != '0' && open_obj.open != '1') && open_obj.activity != '1'">
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:65%"  *ngIf=" open_obj.column == content[i].content && open_obj.open == '1' && open_obj.activity != '1'">
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:65%;transform: rotate(180deg);" *ngIf=" open_obj.column == content[i].content && open_obj.open == '0' || open_obj.activity == '1'">
							</div>
						</div>
						<div style="display: flex;"  *ngIf="!detal.sort && detal.open">
							<div *ngIf="detal.open;" (click)="sort_fnx_open(content[i].content, 1, detal.open)" style="cursor: pointer;">
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:65%" *ngIf="open_obj.column != content[i].content && open_obj.activity != '1' || (open_obj.open != '0' && open_obj.open != '1') && open_obj.activity != '1'" >
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:65%" *ngIf="open_obj.column == content[i].content && open_obj.open == '1' && open_obj.activity != '1'" >
								<img class="icon" src="assets/dist/img/open.png" alt="open Icon" style="width:112%;transform: rotate(180deg);margin-left: -13px;" *ngIf="open_obj.column == content[i].content && open_obj.open == '0' || open_obj.activity == '1'">
							</div>
						</div>
    			    </span>
    			</ng-container>

    			<ng-template #notSortable>
    			    {{ detal.title }}
    			</ng-template>
			</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let dataitem of data; let i = index">
            <td *ngIf="topData.length > 0">
                <input type="checkbox" [(ngModel)]="topData[i].selected" />
            </td>
            <td *ngFor="let item of content" [style]="item.css" >
                <!-- {{item|json}} -->
                <div *ngIf="item.type == 3">
                    <ng-container
                        *ngIf="operationTemplateRef_dk"
                        [ngTemplateOutlet]="operationTemplateRef_dk"
                        [ngTemplateOutletContext]="{$implicit:{idx: i, key:item.content,val:dataitem}}"
                    >
                    </ng-container>
                </div>

                <div *ngIf="item.type == 1">
                    <div class="picborder" *ngIf="bounty_id.includes(dataitem.id)">
                        <p>wanted</p>
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                        <div *ngFor="let bountyitem of bounty_arr">
                            <p *ngIf="bountyitem.user_id == dataitem.id">NT {{bountyitem.diamond}}</p>
                        </div>    
                    </div>
                    <div *ngIf="!bounty_id.includes(dataitem.id)">
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">    
                    </div>
                </div> 
                

                <div *ngIf="item.type == 2">
                    <app-userandactive  [post]="dataitem"></app-userandactive>
                </div> 

                <!-- 過長使用type4 -->
                <div *ngIf="item.type == 4"> 
                    {{ (item.replaceArr ? item.replaceArr[dataitem[item.content]] : (dataitem[item.content] | json)) | slice:0:45 }}{{ (dataitem[item.content] | json).length > 45 ? '...' : '' }}
                </div> 

                <!-- 傳出使用type5 -->
                <div *ngIf="item.type == 5"> 
                    <button class="btn btn-info" role="button" aria-pressed="true" (click)="viewDetailClick(i)">詳細</button>
                </div> 

                <div *ngIf="item.type != 1 && item.type != 2 && item.type != 3 && item.type != 4 && item.type != 5 && item?.model != 1 && item?.model != 2">
                    {{ item.replaceArr ? item.replaceArr[dataitem[item.content]] : dataitem[item.content] | dynamicFormat:item?.format }}
                </div>
                
                <div *ngIf="item?.model == 1">
                    <a href="javascript:void(0)" (click)="handleClick(dataitem[item.handlelinkvalue])">{{ dataitem[item.content] | dynamicFormat:item?.format }}</a>
                </div>
                <div *ngIf="item?.model == 2" [innerHTML]="custom" (click)="handleClick(dataitem)"></div>
            </td>
        </tr>
    </tbody>
</table>


<!-- 手機板 -->
<div *ngIf="isMobile && type == 2 && loadmore != 1">
    <div *ngIf="shouldShowMobileSortPanel()" class="mobile-sort-panel">
        <div class="sort-type">
            <select [(ngModel)]="selectedSortType" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序名稱</option>
                <ng-container *ngFor="let detal of title">
                    <option *ngIf="detal.sort" [value]="detal.sort">{{ detal.title }}</option>
                </ng-container>
            </select>
        </div>
        <div class="sort-order">
            <select [(ngModel)]="selectedSortOrder" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序順序</option>
                <option value="0">由高到低</option>
                <option value="1">由低到高</option>
            </select>
        </div>
    </div>


    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" *ngIf="data.length > 0">
                        <div *ngFor="let item of data let i = index" class="row mb-3">
                            <div class="col-6">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center" *ngFor="let titledetail of title let is = index">
                                            <h5 class="card-title mb-2">{{titledetail.title}}:</h5>
                                            
                                            <div *ngIf="content[is].type == 1">
                                                <img  [src]="item[content[is].content]" alt="" style="width: 30px;margin-left: 10px;">    
                                            </div>
                                            <div *ngIf="content[is].type == 2" style="margin-left: 10px;">
                                                <app-userandactive  [post]="item"></app-userandactive>    
                                            </div>
                                            <div *ngIf="content[is].type == 3" style="margin-left: 10px;">
                                                <ng-container
                                                    *ngIf="operationTemplateRef_dk"
                                                    [ngTemplateOutlet]="operationTemplateRef_dk"
                                                    [ngTemplateOutletContext]="{$implicit:{idx: i, key:content[is].content,val:item}}"
                                                >
                                                </ng-container>
                                                
                                            </div>

        
                                            <!-- 過長使用 type 4 (手機板) -->
                                            <div *ngIf="content[is].type == 4" class="text-truncate d-inline-block" style="max-width: 80%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                <span [title]="item[content[is].content]">
                                                    {{ content[is].replaceArr ? content[is].replaceArr[item[content[is].content]] : (item[content[is].content] | json) | slice:0:45 }}
                                                    {{ (item[content[is].content] | json).length > 45 ? '...' : '' }}
                                                </span>
                                            </div>

                                            <!-- 傳出使用type5 -->
                                            <div *ngIf="content[is].type == 5"> 
                                                <button class="btn btn-info" role="button" aria-pressed="true" (click)="viewDetailClick(i)">詳細</button>
                                            </div> 

                                            <div *ngIf="content[is].type != 1 && content[is].type != 2 && content[is].type != 3 && content[is].type != 4 && content[is].type != 5 && content[is]?.model != 1">
                                                <p class="card-text mb-2 ml-3">{{content[is].replaceArr ? content[is].replaceArr[item[content[is].content]]: item[content[is].content]| dynamicFormat:content[is].format}}</p>
                                            </div>
                                            <div *ngIf="content[is]?.model == 1">
                                                <a href="javascript:void(0)" (click)="handleClick(item.name)">{{item[content[is].content] | dynamicFormat:content[is].format}}</a>
                                            </div>
                                            <div *ngIf="content[is]?.model == 2" [innerHTML]="custom" (click)="handleClick(item)"></div>
                                        </div>   
                                    </div>
                                </div>
                            </div>
                            <!-- 你可以根據需要添加更多的列 -->
                        </div>
                    </div>
                    <div *ngIf="!data.length || data.length == 0" class="no-data text-center mt-4">無資料</div>
                </div>
            </div>
        </div>
        <a *ngIf="showbacktop" (click)="go_top()" id="go_top" onclick="return false" class="back-to-top"> <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i> </a>
    </div>
</div>